import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { ArrowLeft, X } from 'lucide-react';

export default function FullScreenPanel({ isOpen, onClose, title, children, subtitle }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fsp-overlay">
      <div className="fsp-container">
        <div className="fsp-header">
          <div className="fsp-header-left">
            <button className="fsp-back-btn" onClick={onClose}>
              <ArrowLeft size={20} />
            </button>
            <div className="fsp-header-text">
              <h2 className="fsp-title">{title}</h2>
              {subtitle && <span className="fsp-subtitle">{subtitle}</span>}
            </div>
          </div>
          <button className="fsp-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="fsp-body">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
